import {CreateSubprocessChildrenHandler} from './create-subprocess-children-handler';
import {PathwaysModeling} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import {NodeDataCreationHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/node-data-creation-handler';
import {AppendConditionExpressionHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/append-condition-expression-handler';
import {NodeClearDataHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/node-clear-data-handler';
import {NodeResetDataHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/node-reset-data-handler';
import {NodeResetChildrenDataHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/node-reset-children-data-handler';
import {RemoveNodeHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/remove-node-handler';
import {AppendNodeHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/append-node-handler';
import {TreatmentNodeUpdateHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/treatment-node-update-handler';
import {ElementVisibilityHandler} from '@ispm/shared/bpmn-io/handlers/element-visibility-handler';
import {CalculateNodeChildsDataHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/calculate-node-childs-data-handler';
import {NodeNavigatorHandler} from '@ispm/shared/bpmn-io/handlers/node-navigator-handler';
import {PasteNodesHandler} from "@ispm-client/modules/bpmn-modeler/bpmn/commands/paste-nodes-handler";
import {RemoveConnectionHandler} from "@ispm-client/modules/bpmn-modeler/bpmn/commands/remove-connection-handler";
import {CopyNodeHandler} from "@ispm-client/modules/bpmn-modeler/bpmn/commands/copy-node-handler";
import {PathwaysLayoutHandler} from './PathwaysLayoutHandler';
import {CopyNodeHierarchyHandler} from "@ispm-client/modules/bpmn-modeler/bpmn/commands/copy-node-hierarchy-handler";
import {NodeNavigatorWithDataHandler} from '@ispm/shared/bpmn-io/handlers/node-navigator-with-data-handler';

export function getModelerCommandExtensionModule() {
    return {
        __init__: [
            'pathwaysModeling', 'createSubprocessChildrenHandler', 'nodeDataUpdateHandler', 'appendConditionExpressionHandler',
            'calculateNodeChildsDataHandler', 'resetNodeHandler', 'nodeResetDataHandler', 'nodeResetChildrenDataHandler', 'removeNodeHandler',
            'appendNodeHandler', 'treatmentNodeUpdateHandler', 'elementVisibilityHandler', 'nodeNavigatorHandler',
            'copyNodeHandler', 'pasteNodesHandler', 'removeConnectionHandler',
            'copyNodeHierarchyHandler', 'layouter','nodeNavigatowWithDataHandler'
        ],
        pathwaysModeling: ['type', PathwaysModeling],
        createSubprocessChildrenHandler: ['type', CreateSubprocessChildrenHandler],
        nodeDataUpdateHandler: ['type', NodeDataCreationHandler],
        appendConditionExpressionHandler: ['type', AppendConditionExpressionHandler],
        calculateNodeChildsDataHandler: ['type', CalculateNodeChildsDataHandler],
        resetNodeHandler: ['type', NodeClearDataHandler],
        nodeResetDataHandler: ['type', NodeResetDataHandler],
        nodeResetChildrenDataHandler: ['type', NodeResetChildrenDataHandler],
        removeNodeHandler: ['type', RemoveNodeHandler],
        removeConnectionHandler: ['type', RemoveConnectionHandler],
        appendNodeHandler: ['type', AppendNodeHandler],
        treatmentNodeUpdateHandler: ['type', TreatmentNodeUpdateHandler],
        elementVisibilityHandler: ['type', ElementVisibilityHandler],
        nodeNavigatorHandler: ['type', NodeNavigatorHandler],
        copyNodeHandler: ['type', CopyNodeHandler],
        copyNodeHierarchyHandler: ['type', CopyNodeHierarchyHandler],
        pasteNodesHandler: ['type', PasteNodesHandler],
        layouter: ['type', PathwaysLayoutHandler],
        nodeNavigatowWithDataHandler:['type', NodeNavigatorWithDataHandler]
    };
}

